import { render, staticRenderFns } from "./sendTask.vue?vue&type=template&id=2e4622ec&scoped=true"
import script from "./sendTask.vue?vue&type=script&lang=js"
export * from "./sendTask.vue?vue&type=script&lang=js"
import style0 from "./sendTask.vue?vue&type=style&index=0&id=2e4622ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4622ec",
  null
  
)

export default component.exports